export const setObjectInLS = (key, item) => {
    localStorage.setItem(key, JSON.stringify(item));
};

export const getObjectInLS = key => {
    const item = localStorage.getItem(key);

    return JSON.parse(item);
};
